/*eslint-disable*/
export default module => {
  let body = document.querySelector('body')
  let learnMoreSnowe = module.querySelector('.learn-more-snowe')
  let learnMoreSnowePopup = document.querySelector('.learn-more-snowe-popup')
  let learnMoreSummer = module.querySelector('.learn-more-summer')
  let learnMoreSummerPopup = document.querySelector('.learn-more-summer-popup')
  let learnMoreEkobo = module.querySelector('.learn-more-ekobo')
  let learnMoreEkoboPopup = document.querySelector('.learn-more-ekobo-popup')
  let learnMoreLoli = module.querySelector('.learn-more-loli')
  let learnMoreLoliPopup = document.querySelector('.learn-more-loli-popup')

  body.addEventListener('click', (e) => {
    if (e.target !== learnMoreSnowe && e.target !== learnMoreSummer && e.target !== learnMoreEkobo && e.target !== learnMoreLoli && !e.target.closest('.product-details-and-care.popup')) {
      learnMoreSnowePopup.style.display = 'none'
      learnMoreSummerPopup.style.display = 'none'
      learnMoreEkoboPopup.style.display = 'none'
      learnMoreLoliPopup.style.display = 'none'
    }
  })

  learnMoreSnowe.addEventListener('click', () => {
    learnMoreSnowePopup.style.display = 'block'
    learnMoreSummerPopup.style.display = 'none'
    learnMoreEkoboPopup.style.display = 'none'
    learnMoreLoliPopup.style.display = 'none'

    $('#wrapper .content.container').css('overflow', 'hidden')
    $('body').css('overflow', 'hidden')
    $('#wrapper').css('overflow', 'hidden')
    setTimeout(() => {
      $('body').bind('click.snowePopup touchstart.snowePopup', function (e) {
        e.stopImmediatePropagation()
        if (!e.target.closest('.product-details-and-care.popup') || e.target === learnMoreSnowePopup.querySelector('a')) {
          learnMoreSnowePopup.style.display = 'none'
          $('body').unbind('click.snowePopup touchstart.snowePopup')
          $('body').css('overflow', 'auto')
          $('#wrapper').css('overflow', 'auto')
          $('#wrapper .content.container').css('overflow', 'auto')
        }
      })
    }, 10)
  })

  learnMoreSummer.addEventListener('click', () => {
    learnMoreSnowePopup.style.display = 'none'
    learnMoreSummerPopup.style.display = 'block'
    learnMoreEkoboPopup.style.display = 'none'
    learnMoreLoliPopup.style.display = 'none'

    $('#wrapper .content.container').css('overflow', 'hidden')
    $('body').css('overflow', 'hidden')
    $('#wrapper').css('overflow', 'hidden')
    setTimeout(() => {
      $('body').bind('click.summerPopup touchstart.summerPopup', function (e) {
        e.stopImmediatePropagation()
        if (!e.target.closest('.product-details-and-care.popup') || e.target === learnMoreSummerPopup.querySelector('a')) {
          learnMoreSummerPopup.style.display = 'none'
          $('body').unbind('click.summerPopup touchstart.summerPopup')
          $('body').css('overflow', 'auto')
          $('#wrapper').css('overflow', 'auto')
          $('#wrapper .content.container').css('overflow', 'auto')
        }
      })
    }, 10)
  })

  learnMoreEkobo.addEventListener('click', () => {
    learnMoreSnowePopup.style.display = 'none'
    learnMoreSummerPopup.style.display = 'none'
    learnMoreEkoboPopup.style.display = 'block'
    learnMoreLoliPopup.style.display = 'none'

    $('#wrapper .content.container').css('overflow', 'hidden')
    $('body').css('overflow', 'hidden')
    $('#wrapper').css('overflow', 'hidden')
    setTimeout(() => {
      $('body').bind('click.ekoboPopup touchstart.ekoboPopup', function (e) {
        e.stopImmediatePropagation()
        if (!e.target.closest('.product-details-and-care.popup') || e.target === learnMoreEkoboPopup.querySelector('a')) {
          learnMoreEkoboPopup.style.display = 'none'
          $('body').unbind('click.ekoboPopup touchstart.ekoboPopup')
          $('body').css('overflow', 'auto')
          $('#wrapper').css('overflow', 'auto')
          $('#wrapper .content.container').css('overflow', 'auto')
        }
      })
    }, 10)
  })

  learnMoreLoli.addEventListener('click', () => {
    learnMoreSnowePopup.style.display = 'none'
    learnMoreSummerPopup.style.display = 'none'
    learnMoreEkoboPopup.style.display = 'none'
    learnMoreLoliPopup.style.display = 'block'

    $('#wrapper .content.container').css('overflow', 'hidden')
    $('body').css('overflow', 'hidden')
    $('#wrapper').css('overflow', 'hidden')
    setTimeout(() => {
      $('body').bind('click.loliPopup touchstart.loliPopup', function (e) {
        e.stopImmediatePropagation()
        if (!e.target.closest('.product-details-and-care.popup') || e.target === learnMoreLoliPopup.querySelector('a')) {
          learnMoreLoliPopup.style.display = 'none'
          $('body').unbind('click.loliPopup touchstart.loliPopup')
          $('body').css('overflow', 'auto')
          $('#wrapper').css('overflow', 'auto')
          $('#wrapper .content.container').css('overflow', 'auto')
        }
      })
    }, 10)
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/birthday-gwp-value-module.js